import { render, staticRenderFns } from "./TNMessage.vue?vue&type=template&id=534e18f0&"
import script from "./TNMessage.vue?vue&type=script&lang=js&"
export * from "./TNMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports